export default "__VITE_ASSET__Dl4LE22e__"